package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.models.EquipRepairRequestDTO
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun AdminEquipmentRepairsForm(
    toUpdateEquipRepairReq: EquipRepairRequestDTO? = null,
    onSubmit: (EquipRepairRequestDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var equipRepairState by remember(toUpdateEquipRepairReq) {
        mutableStateOf(
            toUpdateEquipRepairReq?.copy() ?: EquipRepairRequestDTO()
        )
    }

    LaunchedEffect(Unit) {
        //Necessary for loading default value, and having it still be editable.

        /* Tractor Needs and Service setting value */
        val tractorNeedsTextArea = (document.getElementById(InputIDs.EquipRepairForm.tractorNeeds) as HTMLTextAreaElement)
        tractorNeedsTextArea.value = equipRepairState.tractorNeeds
        val tractorOutNoCheck = (document.getElementById(InputIDs.EquipRepairForm.tractorOutNo) as HTMLInputElement)
        val tractorOutYesCheck = (document.getElementById(InputIDs.EquipRepairForm.tractorOutYes) as HTMLInputElement)
        tractorOutNoCheck.checked = (!equipRepairState.tractorService)
        tractorOutYesCheck.checked = (equipRepairState.tractorService)

        /* Tractor Needs and Service setting value */
        val trailerNeedsTextArea = (document.getElementById(InputIDs.EquipRepairForm.trailerNeeds) as HTMLTextAreaElement)
        trailerNeedsTextArea.value = equipRepairState.trailerNeeds
        val trailerOutNoCheck = (document.getElementById(InputIDs.EquipRepairForm.trailerOutNo) as HTMLInputElement)
        val trailerOutYesCheck = (document.getElementById(InputIDs.EquipRepairForm.trailerOutYes) as HTMLInputElement)
        trailerOutNoCheck.checked = (!equipRepairState.trailerService)
        trailerOutYesCheck.checked = (equipRepairState.trailerService)
    }


    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "ID: ${equipRepairState.id}",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /* Specific Form Rows Here */
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Name*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Row(
                        modifier = Modifier
                            .gap(20.px)
                    ) {
                        Input(
                            type = InputType.Text,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.firstname)
                                .fillMaxWidth()
                                .height(54.px)
                                .margin(topBottom = 12.px)
                                .padding(leftRight = 20.px)
                                .backgroundColor(Theme.LightGray.rgb)
                                .borderRadius(r = 4.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )
                                .fontFamily(FONT_FAMILY)
                                .fontSize(16.px)
                                .toAttrs {
                                    attr("placeholder", "First Name")
                                    attr("value", equipRepairState.firstName) // Set value from DTO

                                }
                        )

                        Input(
                            type = InputType.Text,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.lastname)
                                .fillMaxWidth()
                                .height(54.px)
                                .margin(topBottom = 12.px)
                                .padding(leftRight = 20.px)
                                .backgroundColor(Theme.LightGray.rgb)
                                .borderRadius(r = 4.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )
                                .fontFamily(FONT_FAMILY)
                                .fontSize(16.px)
                                .toAttrs {
                                    attr("placeholder", "Last Name")
                                    attr("value", equipRepairState.lastName) // Set value from DTO
                                }
                        )
                    }

                }


            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Date*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Date,
                        attrs = Modifier
                            .id(InputIDs.EquipRepairForm.date)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                attr("value", equipRepairState.date) // Set value from DTO
                            }
                    )
                }
            }

            HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Tractor Unit #*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .id(InputIDs.EquipRepairForm.tractorUnit)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .toAttrs {
                                attr("placeholder", "")
                                attr("value", equipRepairState.tractorUnit) // Set value from DTO
                            }
                    )

                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Explain Tractor Repairs Needed*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    TextArea(
                        attrs = Modifier
                            .id(InputIDs.EquipRepairForm.tractorNeeds)
                            .fillMaxWidth()
                            .height(175.px)
                            .maxHeight(400.px)
                            .margin(top = 8.px)
                            .padding(all = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(4.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .resize(Resize.None)
                            .toAttrs{
                                attr("placeholder", "As Detailed as possible")
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .margin(topBottom = 12.px)
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Out Of Service?",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )


                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.tractorOutNo)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )
                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.EquipRepairForm.tractorOut)
                                    value("false")
                                    checked(true)
                                }
                        )

                        Label(
                            forId = InputIDs.EquipRepairForm.tractorOutNo,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text("No")
                        }
                    }

                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.tractorOutYes)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )

                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.EquipRepairForm.tractorOut)
                                    value("true")
                                }
                        )

                        Label(
                            forId = InputIDs.EquipRepairForm.tractorOutYes,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text("Yes")
                        }
                    }
                }
            }

            HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Trailer Unit #*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .id(InputIDs.EquipRepairForm.trailerUnit)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .toAttrs {
                                attr("placeholder", "")
                                attr("value", equipRepairState.trailerUnit) // Set value from DTO
                            }
                    )

                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Explain Trailer Repairs Needed*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    TextArea(
                        attrs = Modifier
                            .id(InputIDs.EquipRepairForm.trailerNeeds)
                            .fillMaxWidth()
                            .height(175.px)
                            .maxHeight(400.px)
                            .margin(top = 8.px)
                            .padding(all = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(4.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .resize(Resize.None)
                            .toAttrs{
                                attr("placeholder", "As Detailed as possible")
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .margin(topBottom = 12.px)
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Out Of Service?",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )


                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.trailerOutNo)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )
                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.EquipRepairForm.trailerOut)
                                    value("false")
                                    checked(true)
                                }
                        )

                        Label(
                            forId = InputIDs.EquipRepairForm.trailerOutNo,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text("No")
                        }
                    }

                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.EquipRepairForm.trailerOutYes)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )

                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.EquipRepairForm.trailerOut)
                                    value("true")
                                }
                        )

                        Label(
                            forId = InputIDs.EquipRepairForm.trailerOutYes,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text("Yes")
                        }
                    }
                }
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )


            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    equipRepairState = equipRepairState.copy(
                        firstName = (document.getElementById(InputIDs.EquipRepairForm.firstname) as HTMLInputElement).value,
                        lastName = (document.getElementById(InputIDs.EquipRepairForm.lastname) as HTMLInputElement).value,
                        date = (document.getElementById(InputIDs.EquipRepairForm.date) as HTMLInputElement).value,
                        tractorUnit = (document.getElementById(InputIDs.EquipRepairForm.tractorUnit) as HTMLInputElement).value,
                        tractorNeeds = (document.getElementById(InputIDs.EquipRepairForm.tractorNeeds) as HTMLTextAreaElement).value,
                        tractorService = (document.querySelector("input[name='equiprepairtractorout']:checked") as HTMLInputElement).value.toBoolean(),
                        trailerUnit = (document.getElementById(InputIDs.EquipRepairForm.trailerUnit) as HTMLInputElement).value,
                        trailerNeeds = (document.getElementById(InputIDs.EquipRepairForm.trailerNeeds) as HTMLTextAreaElement).value,
                        trailerService = (document.querySelector("input[name='equiprepairtrailerout']:checked") as HTMLInputElement).value.toBoolean(),
                    )

                    if (
                        equipRepairState.firstName.isNotEmpty() &&
                        equipRepairState.lastName.isNotEmpty() &&
                        equipRepairState.date.isNotEmpty()
                    ) {
                        errorText = " "
                        showConfirmModal = true



                    } else {
                        errorText = "Please fill out all required fields."
                    }

                }
            )




            if (showConfirmModal) {
                ConfirmModal(
                    actionText = "Update Contact",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(equipRepairState)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}
